import {
  SUBMIT_INSTALLATION_DATA,
  SUBMIT_PERSON_DATA,
  SUBMIT_PAYMENT_DATA,
  SUBMIT_CONTRACT_DATA,
  SUBMIT_DUAL_GAS_CONTRACT_DATA,
  SUBMIT_CONFIRMATION_DATA,
  NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST,
  NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE,
  RECEIVE_CONTRACTATION_CONFIG,
  RECEIVE_DUAL_CONTRACTATION_CONFIG,
  SET_LEAD_ID,
  SET_GAS_LEAD_ID,
  SET_LEAD_STEP_CURRENT,
  SET_LEAD_INDEX_COMPLETED,
  SET_LEAD_ERRORS,
  SET_LEAD_SUBMIT_REQUEST,
  RESET_CONTRACTATION
} from "../../../constants";
import { createReducer } from "../../../utils/misc";
import electricityContractationInitialState from "./electricityContractationInitialState";

export const reducerMap = {
  [SET_LEAD_ID]: (state, payload) => 
    Object.assign({}, state, {
      leadId: payload.leadId,
  }),
  [SET_GAS_LEAD_ID]: (state, payload) => ({
      ...state,
      gasLeadId: payload,
  }),
  [SET_LEAD_STEP_CURRENT]: (state, payload) =>
    Object.assign({}, state, {
      currentStep: {
        index: payload.index,
        name: payload.name
      }
  }),
  [SET_LEAD_INDEX_COMPLETED]: (state, payload) =>
    Object.assign({}, state, {
      completedSteps: {
        ...state.completedSteps,
        [payload.stepIndex]: true
      },
      latestStep: payload.stepIndex + 1,
      submitting: false
  }),
  [SET_LEAD_SUBMIT_REQUEST]: (state) =>
   Object.assign({}, state, {
    submitting: true,
  }),
  [SET_LEAD_ERRORS]: (state, payload) => {
    return {
      ...state,
      leadErrors: {
        ...state.leadErrors,
        ...payload
      }
    }
  },
  [SUBMIT_INSTALLATION_DATA]: (state, payload) => {
    const newState = {
      ...state,
      leadsConsent: payload.leadsConsent,
      steps: {
        ...state.steps,
        installation: {...payload}
      }
    };
    return newState;
  },
  [SUBMIT_PERSON_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        person: payload
      }
    }
  },
  [SUBMIT_CONTRACT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        contract: payload
      }
    }
  },
  [SUBMIT_DUAL_GAS_CONTRACT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        dualGasContract: payload
      }
    }
  },
  [SUBMIT_PAYMENT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        payment: payload
      }
    }
  },
  [SUBMIT_CONFIRMATION_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          ...payload
        }
      }
    }
  },
  [NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST]: (state) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          isConfirming: true
        }
      }
    }
  },
  [NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          ...payload,
          isConfirming: false
        }
      }
    }
  },
  // [FETCH_CONTRACTATION_CONFIG_REQUEST]: (state, payload) => {
  //   return {
  //     ...state,
  //     isFetching: true
  //   }
  // },
  [RECEIVE_CONTRACTATION_CONFIG]: (state, payload) => {
    return {
      ...state,
      config: {
        ...state.config,
        ...(payload ? payload : {}),
        isFetching: false
      }
    }
  },
  [RECEIVE_DUAL_CONTRACTATION_CONFIG]: (state, payload) => {
    return {
      ...state,
      gasConfig: {
        ...state.gasConfig,
        ...(payload ? payload : {}),
        isFetching: false
      }
    }
  },
  [RESET_CONTRACTATION]: (state) => {
    return electricityContractationInitialState;
  }
};

export default createReducer(electricityContractationInitialState, reducerMap);